"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var reactstrap_1 = require("reactstrap");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.setHistory = function (history) {
            _this.history = history;
        };
        _this.renderLinks = function () {
            React.createElement("div", { style: { position: "absolute", display: "flex", right: "5%" } },
                React.createElement(react_router_dom_1.Route, { render: function (_a) {
                        var history = _a.history;
                        _this.setHistory(history);
                        return (React.createElement("div", { style: { display: "flex", fontSize: "16px" } },
                            React.createElement("div", { onClick: function () { return _this.route('/'); }, style: { cursor: "pointer" } },
                                React.createElement("span", { style: { lineHeight: "48px", verticalAlign: "middle" } }, "Startseite")),
                            React.createElement("div", { onClick: function () { return _this.route('/Speisekarte'); }, style: { cursor: "pointer" } },
                                React.createElement("span", { style: { lineHeight: "48px", verticalAlign: "middle" } }, "Speisekarte"))));
                    } }));
        };
        _this.route = function (path) {
            _this.history.push({
                pathname: path
            });
        };
        return _this;
    }
    Layout.prototype.render = function () {
        var theme = office_ui_fabric_react_1.Customizations.getSettings(["theme"]).theme;
        return (React.createElement("div", { style: { margin: 0 } },
            React.createElement("div", null,
                React.createElement("header", null,
                    React.createElement("div", { style: { height: "25px", color: "white", display: "flex" } }))),
            React.createElement("div", { className: "clearfix" },
                React.createElement("div", { className: "right" },
                    React.createElement(reactstrap_1.Container, { style: { margin: "0px", padding: "0px", maxWidth: "100%" } }, this.props.children))),
            React.createElement("div", null,
                React.createElement("footer", { style: { marginTop: "20px" } },
                    React.createElement("div", { style: { backgroundColor: theme.palette.themePrimary, width: "100%", textAlign: "center", color: "white" } },
                        React.createElement("div", { style: { display: "inline-block", margin: "25px auto" } },
                            React.createElement("p", null, "Verler Grillhouse - inh. Joanna Jadczak - Hauptstra\u00DFe 23 - 33415 Verl - 05246 934010 - verler.grillhouse@freenet.de")))))));
    };
    return Layout;
}(React.Component));
exports.default = Layout;
//# sourceMappingURL=Layout.js.map